 $(document).ready(function() {


     // Popular apps slider
     toggleNav();
     magnificPopup();
     animateAnchor();
     stickyNav();
     slick_slider();
     playVideo();
    
     $(window).resize(slick_slider);

     function toggleNav() {
         // Togglefunction for the mobile menu. If toggled, a class is added to the body
         $("#nav-trigger").on('click', function(e) {

           e.preventDefault();
           if ($('body').hasClass('open-nav')) {
               $('body').removeClass('open-nav');
           } else {
               $('body').addClass('open-nav');
           }
       });

         $(".menu-item a").on('click', function(e) {
           if ($('body').hasClass('open-nav')) {
               setTimeout(function() {
                   $('body').removeClass('open-nav');
               }, 700);
           }
       });
     };

     function magnificPopup() {
       $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
           disableOn: 700,
           type: 'iframe',
           mainClass: 'mfp-fade',
           removalDelay: 160,
           preloader: false,
           fixedContentPos: true,
           callbacks: {
               beforeOpen: function() {
                   startWindowScroll = $(window).scrollTop();
               },
               close: function() {
                   $(window).scrollTop(startWindowScroll);
               }
           }
       });
   };

   function animateAnchor() {
       $('a[href^="#"]').click(function() {

           var the_id = $(this).attr("href");
           $('html, body').animate({
               scrollTop: $(the_id).offset().top
           }, 2000);

           $('body').removeClass('open-nav');
           return false;
       });
   };

   function get_viewport_size() {
       var e = window,
       a = 'inner';
       if (!('innerWidth' in window)) {
           a = 'client';
           e = document.documentElement || document.body;
       }
       return { width: e[a + 'Width'], height: e[a + 'Height'] };
   };

   function stickyNav() {
    if( get_viewport_size().width < 1200 ) {
       if ($(window).scrollTop() > 40) {
           $('body').addClass('stickyNav');
       } else {
           $('body').removeClass('stickyNav');
       }
   } else {
    $('body').addClass('stickyNav');
}
};

function slick_slider() {
    var wrapper = $(".slider");
    wrapper.slick({
       mobileFirst: true,
       slidesToShow: 1,
       slidesToScroll: 1,
       arrows: true,
       dots: false,
       appendArrows: $('.slick_nav'),
       nextArrow: '<div class="slick-button"><i class="fa fa-arrow-right next"></i></div>',
       prevArrow: '<div class="slick-button"><i class="fa fa-arrow-left prev"></i></div>',


   });
}
function playVideo() {
        // alert('hierzo');
        var iframe = $('#player1')[0];
        var player = $f(iframe);


        $('.video__play--inline').on('click', function(e) {
            console.log('clickety');
            e.preventDefault();
            $('.textpage__video_overlay').hide();
            $('.textpage__video img').css('opacity', '0');
            $('.textpage__video iframe').css('z-index', '2');
            player.api("play");

            // $('.textpage__video img').hide();
        });
    }
    var min_w = 300; // minimum video width allowed
var vid_w_orig;  // original video dimensions
var vid_h_orig;

jQuery(function() { // runs after DOM has loaded

  vid_w_orig = parseInt(jQuery('video').attr('width'));
  vid_h_orig = parseInt(jQuery('video').attr('height'));
  $('#debug').append("<p>DOM loaded</p>");

  jQuery(window).resize(function () { resizeToCover(); });
  jQuery(window).trigger('resize');
});


$(window).on('resize scroll', function() {
   stickyNav();
});

});